import React from 'react';

const QuestionStep = ({ question, value, onAnswer, showIcons = false }) => {
  // §preview may clone the question with option icons + showIcons; inert otherwise.
  const iconsOn = showIcons || !!question.showIcons;
  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-8">
        {question.question}
      </h2>

      {/* Subtitle if exists */}
      {question.subtitle && (
        <p className="text-center text-gray-500 mb-6 -mt-4">
          {question.subtitle}
        </p>
      )}

      {/* Options */}
      <div className="space-y-3">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => onAnswer(option.value || option)}
            className={`option-card w-full p-5 rounded-xl text-left transition-all ${
              value === (option.value || option) ? 'selected' : ''
            }`}
            data-testid={`option-${index}`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {/* Icon if available and showIcons is true */}
                {iconsOn && option.icon && (
                  <span className="text-2xl">{option.icon}</span>
                )}
                <span className="text-base font-medium text-gray-800">
                  {option.label || option}
                </span>
              </div>
              {/* Radio button indicator */}
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                value === (option.value || option)
                  ? 'border-[#2d8a5f] bg-[#2d8a5f]'
                  : 'border-gray-300'
              }`}>
                {value === (option.value || option) && (
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
            </div>
            {option.description && (
              <p className="text-sm text-gray-500 mt-1 ml-9">{option.description}</p>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuestionStep;
